import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { apiCall } from '../utils/api';

function ViewModule() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [module, setModule] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchModuleData = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await apiCall(`/modules/${id}`);
        setModule(data);
      } catch (error) {
        console.error('Error fetching module:', error);
        setError(error.message || 'Failed to load module');
        setModule(null);
      } finally {
        setLoading(false);
      }
    };

    fetchModuleData();
  }, [id]);

  if (loading) {
    return <div className="container mt-4">Loading module details...</div>;
  }

  if (error) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger">
          Error loading module: {error}
        </div>
        <button className="btn btn-secondary" onClick={() => navigate('/module_list')}>
          Back to Module List
        </button>
      </div>
    );
  }

  if (!module) {
    return (
      <div className="container mt-4">
        <div className="alert alert-warning">
          Module not found.
        </div>
        <button className="btn btn-secondary" onClick={() => navigate('/module_list')}>
          Back to Module List
        </button>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <h1>View Module</h1>

      <form>
        <label>Module ID:</label>
        <input
          type="text"
          name="module_id"
          value={module['Module ID']}
          readOnly
          className="form-control"
          style={{ backgroundColor: '#d6d6d6', color: '#333' }}
        />

        <label>Module Description:</label>
        <input
          type="text"
          name="module_description"
          value={module['Module Description']}
          readOnly
          className="form-control"
          style={{ backgroundColor: '#d6d6d6', color: '#333' }}
        />

        <table className="table table-bordered mt-2">
          <thead>
            <tr>
              <th>Step Number</th>
              <th>Description</th>
              <th>URL</th>
            </tr>
          </thead>
          <tbody id="steps-table">
            {module.Steps.map((step, index) => (
              <tr key={index}>
                <td>
                  <input
                    type="text"
                    name="step_number[]"
                    value={step['Step Number']}
                    readOnly
                    className="form-control"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    name="description[]"
                    value={step.Description}
                    readOnly
                    className="form-control"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    name="step_url[]"
                    value={step.URL}
                    readOnly
                    className="form-control"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <label>Modified By:</label>
        <input
          type="text"
          name="modified_by"
          value={module.ModifiedBy}
          readOnly
          className="form-control"
          style={{ backgroundColor: '#d6d6d6', color: '#333' }}
        />
      </form>

      <div className="mt-3 d-flex justify-content-end gap-2">
        <button type="button" className="btn btn-secondary" onClick={() => navigate('/module_list')}>
          Back
        </button>
      </div>
    </div>
  );
}

export default ViewModule;
